module.exports = __webpack_public_path__ + "static/img/image_news_over_09.2f64c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_09.png
// module id = DRm2
// module chunks = 10